import {getSetting} from '@woocommerce/settings';
import {registerPaymentMethod, registerExpressPaymentMethod} from '@wc-stripe/blocks-express-checkout';
import {ExpressCheckoutContent} from '../express-checkout';
import {PaymentMethod, PaymentMethodLabel} from '@wc-stripe/blocks-components';
import {isCartPage} from '@wc-stripe/blocks-utils';
import GooglePayPreview from "./preview";
import SavedCardComponent from "../saved-card-component";
import './style.scss';

const data = getSetting('stripe_googlepay_data');
const activeMethod = {googlePay: data.displayRule};

registerPaymentMethod({
    name: data.gatewayId,
    label: <PaymentMethodLabel
        title={data.title}
        paymentMethod={data.gatewayId}
        icons={data.icons}/>,
    ariaLabel: 'Google Pay',
    activeMethod,
    availabilityKey: 'googlePay',
    context: 'checkout',
    sections: data.sections,
    content: (
        <PaymentMethod
            data={data}
            name={data.gatewayId}
            activeMethod={activeMethod}
            isExpress={false}
            content={ExpressCheckoutContent}
        />
    ),
    edit: <GooglePayPreview data={data}/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: false,
        features: data.features
    }
});

registerExpressPaymentMethod({
    name: 'stripe_googlepay_express',
    gatewayId: data.gatewayId,
    paymentMethodId: data.gatewayId,
    activeMethod,
    availabilityKey: 'googlePay',
    context: () => isCartPage() ? 'cart' : 'express_checkout',
    sections: data.sections,
    content: (
        <ExpressCheckoutContent
            data={data}
            name={'stripe_googlepay_express'}
            activeMethod={activeMethod}
        />
    ),
    savedTokenComponent: <SavedCardComponent data={data}/>,
    edit: <GooglePayPreview data={data}/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: data.showSaveOption,
        features: data.features
    }
});